import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-page-subtitle",
    templateUrl: "./sps-page-subtitle.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsPageSubtitleComponent {
    @HostBinding("class.sps-page-title__subtitle") readonly _spsPageSubtitleClass = true;
}
